export const ServiceGroupIcon = {
  '效率工具服务': 'assets/icons/group-icon/productivity-tools',
  '数据安全服务': 'assets/icons/group-icon/data-security',
  '终端安全服务': 'assets/icons/group-icon/terminal-security',
  '资产管理服务': 'assets/icons/group-icon/assets-mange',
  '终端运维服务': 'assets/icons/group-icon/terminal-om',
  '上网管控服务': 'assets/icons/group-icon/internet-control',
  '终端优化服务': 'assets/icons/group-icon/terminal-optimization',
  '办公效率服务': 'assets/icons/group-icon/office-efficiency',
}

export const ServiceGroupSort = [
  '效率工具服务',
  '数据安全服务',
  '终端运维服务',
  '终端优化服务',
  '办公效率服务',
  '上网管控服务',
  '终端安全服务',
  '资产管理服务',
]
